module.exports = __webpack_public_path__ + "media/light-towers.75d55cd7.mp4";